/**
 * @name DenialCriteria.Entry.js
 * @author AnchorGroup : Kalpa
 * @description Used to track user's IP address or email.
 * @update 2025-07-18
 */
define(
	'DenialCriteria.Entry'
,   [
		'DenialCriteria.SS2Model'
	]
,   function (
		DenialCriteriaSS2Model
	)
{
	'use strict';
	return  {
		mountToApp: function mountToApp (container)
		{
			var model = new DenialCriteriaSS2Model(),
			promise = model.fetch();
			container.waitForPromise(promise);
		}
	};
});
